import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";
import CardMedia from "@mui/material/CardMedia";

import DataTable from "examples/Tables/DataTable";
import Actionables from "components/UpStyled/Actionables";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import TableRowsIcon from "@mui/icons-material/TableRows";
import GridViewIcon from "@mui/icons-material/GridView";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import PageviewIcon from "@mui/icons-material/Pageview";
import EditIcon from "@mui/icons-material/Edit";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import NoteAddIcon from "@mui/icons-material/NoteAdd";

import { budgetOptions, MANUFACTURER_SERVICES } from "utils/data";
import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Switch from "@mui/material/Switch";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "antd";
import UTreeSelect from "components/UpStyled/UTreeSelect";

import { filterParser, sortParser } from "utils/helper";
import { stylesSortOptions, seasonOptions } from "utils/data";
import { handleUploadFiles, getStyleImages, canResizeImageUrl } from "utils/imageHelper";

import EmptyColorCard from "pages/de/palette/components/EmptyColorCard";
import CreateColorModal from "pages/de/palette/components/CreateColorModal";

import Error404 from "pages/error/404";
const Color = require("color");

const Palette = ({ sharedView = false }) => {
  const [data, setData] = useState([]);

  const [createColorVisible, setCreateColorVisible] = useState(false);
  const [editColorVisible, setEditColorVisible] = useState(false);
  const [selectedColor, setSelectedColor] = useState({});

  const [deleteVisible, setDeleteVisible] = useState(false);

  const [loading, setLoading] = useState(false);

  let location = useLocation();
  const navigate = useNavigate();

  const user = useContext(AccountContext);

  const {
    tree,
    actions: { findNodeByID, findParents },
  } = useContext(CategoryContext);

  useEffect(() => {
    retrievePalette();
  }, []);

  const retrievePalette = async () => {
    try {
      const { data } = await api.palette.list({
        order: "-updated_at",
      });
      setData(data?.colors || []);
    } catch (err) {
      toast.error(`Retrieve color list failed!`);
      console.log(err);
    }
  };

  const handleDeleteColor = async (color) => {
    try {
      await api.palette.delete(color.id);
      setDeleteVisible(false);
      retrievePalette();

      toast.success(`${color.name} has been removed successfully!`);
    } catch (err) {
      toast.error(`${color.name} could not be removed!`);
      console.log(err);
    }
  };

  const getStyleTableRow = (item) => {
    let seasonOpt = seasonOptions.find((x) => x.value == item.season) || {};
    if (item.season && !seasonOpt.value) {
      seasonOpt = { label: item.season, value: item.season };
    }

    let color = undefined;
    try {
      color = Color(item?.hex);
    } catch (err) {}

    return {
      key: item.id,
      name: item?.name,
      color: item?.hex,
      hex: item?.hex,
      rgb: color ? color.rgb().array().join(",") : undefined,
      year: item?.metadata?.year ? moment(item?.metadata?.year).format("YYYY") : "",
      season: seasonOpt?.value,
      note: item.note,
      created_at: item.created_at,
      updated_at: item.updated_at,
      action: item,
    };
  };

  const columns = [
    {
      Header: "Color",
      accessor: "color",
      align: "center",
      Cell: ({ row, value }) => {
        return <input value={value} type="color" readOnly disabled />;
      },
    },
    {
      Header: "Color Name",
      accessor: "name",
    },
    {
      Header: "HEX",
      accessor: "hex",
    },
    {
      Header: "RGB",
      accessor: "rgb",
    },
    {
      Header: "Year",
      accessor: "year",
    },
    {
      Header: "Season",
      accessor: "season",
    },
    {
      Header: "Notes",
      accessor: "note",
      Cell: ({ row, value }) => {
        return (
          <Tooltip title={value}>
            <div
              style={{
                wordBreak: "break-word",
                maxWidth: 200,
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
              }}
            >
              {value}
            </div>
          </Tooltip>
        );
      },
    },
    {
      Header: "Last Edit",
      accessor: "updated_at",
      Cell: ({ row, value }) => {
        return value ? moment(value).format("MM/DD/YY") : "";
      },
    },
    {
      Header: "More",
      accessor: "action",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => (
        <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
          <Tooltip title="View Details">
            <SuiBox component={Link} to={`/setup/color-master/${value.id}`}>
              <ManageSearchIcon fontSize={"small"} color="dark" />
            </SuiBox>
          </Tooltip>
          |
          <Tooltip title="Edit">
            <SuiBox>
              <EditIcon
                fontSize={"small"}
                color="dark"
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedColor(value);
                  setEditColorVisible(true);
                }}
              />{" "}
            </SuiBox>
          </Tooltip>
          |{" "}
          <Tooltip title="Delete">
            <SuiBox>
              <DeleteForeverRoundedIcon
                fontSize={"small"}
                color="error"
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedColor(value);
                  setDeleteVisible(true);
                }}
              />{" "}
            </SuiBox>
          </Tooltip>
        </SuiBox>
      ),
    },
  ];

  const refresh = () => {
    retrievePalette();
  };

  const rows = data.map((item) => getStyleTableRow(item));

  const handleRowClick = (row) => {
    navigate(`/setup/color-master/${row?.original?.key}`);
  };

  return (
    <SuiBox my={1}>
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={loading}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
      </Backdrop>
      <SuiBox display="flex" justifyContent="space-between" pb={1}>
        <SuiButton
          variant="gradient"
          color={"dark"}
          onClick={() => {
            setCreateColorVisible(true);
          }}
        >
          New Color
        </SuiButton>
      </SuiBox>

      <Card sx={{ p: 3 }}>
        {rows.length > 0 ? (
          <DataTable
            table={{ columns, rows: rows }}
            entriesPerPage={{ defaultValue: 20 }}
            noEndBorder
            handleRowClick={handleRowClick}
          />
        ) : (
          <EmptyColorCard refresh={refresh} />
        )}
      </Card>
      {createColorVisible ? (
        <CreateColorModal
          handleClose={() => setCreateColorVisible(false)}
          visible={createColorVisible}
          isEdit={false}
          handleRefresh={refresh}
        />
      ) : null}
      {editColorVisible && selectedColor ? (
        <CreateColorModal
          handleClose={() => setEditColorVisible(false)}
          visible={editColorVisible}
          isEdit={true}
          handleRefresh={refresh}
          color={selectedColor}
        />
      ) : null}
      {deleteVisible && selectedColor ? (
        <Prompt
          heading="Delete Color"
          text={`Are you sure you want to delete: ${selectedColor.name}`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={() => handleDeleteColor(selectedColor)}
          handleClose={() => setDeleteVisible(false)}
        />
      ) : null}
    </SuiBox>
  );
};

export default Palette;
